import { css } from "@emotion/react";

import SafeImage from "~/components/common/SafeImage";
import {
  ExamSignupContext,
  examSignupDescription,
  examSignupHeading,
} from "~/lib/client/signupExamContext";

const ExamSignupHeader = ({ context }: { context: ExamSignupContext }) => (
  <div css={rootStyle}>
    {context.examVisual && (
      <div css={visualStyle}>
        <SafeImage
          src={context.examVisual.url}
          alt={context.examVisual.alt}
          fill
          sizes="(max-width: 600px) calc(100vw - 64px), 416px"
          css={imageStyle}
          priority
        />
      </div>
    )}
    <h1 css={headingStyle}>{examSignupHeading(context)}</h1>
    <p css={descriptionStyle}>{examSignupDescription(context)}</p>
  </div>
);

const rootStyle = css`
  width: 100%;
  text-align: center;
  margin-bottom: 1.25rem;
`;

const visualStyle = css`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  margin-bottom: 1rem;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
`;

const imageStyle = css`
  object-fit: contain;
`;

const headingStyle = css`
  margin: 0 0 0.75rem;
  font-size: 1.35rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
`;

const descriptionStyle = css`
  margin: 0;
  color: #555;
  font-size: 0.9rem;
  line-height: 1.7;
  text-align: left;
  white-space: pre-line;
`;

export default ExamSignupHeader;
